export const coursesConstants = {
  COURSES_INIT: '[Courses] init',
  COURSES_UPDATE: '[Courses] Update',
  COURSES_REMOVE: '[Courses] Remove'
}
